export { StyleColorSocialInstagram } from "./StyleColorSocialInstagram";
